import * as React from 'react';
import { FC } from 'react';

import { AdSlot, Size } from 'react-dfp';
import styled from 'styled-components';

import { useGoogleAds } from 'hooks/use-google-ads';
import { useAuthContext } from 'state/auth';
import { useLocale } from 'state/intl';
import { isNative } from 'utils/environment';

import { IGoogleAdSlotProps } from './types';

const AdSlotWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
`;

// Use this to hold allowed sizes
// for converting Sanity string to
// expected Size type
const sizeStringsToSizesArray = {
  '320x50': [320, 50],
  '300x250': [300, 250],
};

const getTileIdFromAdUnit = (adUnit: string) => {
  const splitAdUnit = adUnit.split('-');
  return splitAdUnit[splitAdUnit.length - 1];
};

/**
 *
 * GoogleAdSlot wraps the react-dfp AdSlot component
 *  to enable conditional rendering based on LD flag
 *  and coersion of Sanity data into expected props
 *
 */
const GoogleAdSlot: FC<IGoogleAdSlotProps> = ({ adUnit, sizes }) => {
  const { user } = useAuthContext();
  const { isEnabled, campaignId } = useGoogleAds();
  const { language } = useLocale();

  if (!isEnabled || !campaignId || !adUnit) {
    return null;
  }

  const targetingArguments = {
    language,
    lid: user?.thLegacyCognitoId ?? '',
    platform: isNative ? 'app' : 'web',
    Tile: getTileIdFromAdUnit(adUnit),
  };
  /**
   * NOTE: currently the size is configured in Sanity.
   *       only one selection is allowed, and it is a string.
   *       AdSlot expects and array of Size types so we
   *       need to convert the Sanity string to AdSlot Size
   *       (if an approved size), and push to parent array.
   */
  let sizesProp: Size[] = [];
  if (typeof sizes === 'string') {
    const sizeArr = sizeStringsToSizesArray[sizes];
    if (sizeArr) {
      sizesProp.push(sizeArr);
    }
  }
  return (
    <AdSlotWrapper>
      <AdSlot sizes={sizesProp} adUnit={adUnit} targetingArguments={targetingArguments} />
    </AdSlotWrapper>
  );
};

export default GoogleAdSlot;
